module.exports = __webpack_public_path__ + "img/bank_10.036b7f14.png";